/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of metric for score accumulation strategy
 * @export
 */
export const MetricType = {
    KILLS: 'KILLS',
    DEATHS: 'DEATHS',
    ASSISTS: 'ASSISTS',
    SCORE: 'SCORE',
    HEADSHOTS: 'HEADSHOTS',
    DAMAGE: 'DAMAGE',
    WINS: 'WINS',
    PLAYTIME: 'PLAYTIME',
    XP: 'XP',
    CUSTOM: 'CUSTOM'
} as const;
export type MetricType = typeof MetricType[keyof typeof MetricType];


export function instanceOfMetricType(value: any): boolean {
    for (const key in MetricType) {
        if (Object.prototype.hasOwnProperty.call(MetricType, key)) {
            if (MetricType[key as keyof typeof MetricType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MetricTypeFromJSON(json: any): MetricType {
    return MetricTypeFromJSONTyped(json, false);
}

export function MetricTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricType {
    return json as MetricType;
}

export function MetricTypeToJSON(value?: MetricType | null): any {
    return value as any;
}

export function MetricTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): MetricType {
    return value as MetricType;
}

